// @core/api/endpoints/authz/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { BatchCheck } from './batch_check';
import { Check } from './check';
import { DeleteTuples } from './delete_tuples';
import { Expand } from './expand';
import { ListAuthorizationModels } from './list_authorization_models';
import { ListObjects } from './list_objects';
import { ListUsersByObject } from './list_users_by_object';
import { ReadAuthorizationModel } from './read_authorization_model';
import { ReadTuples } from './read_tuples';
import { WriteAuthorizationModel } from './write_authorization_model';
import { WriteTuples } from './write_tuples';

// Re-export individual endpoints
export {
  BatchCheck,
  Check,
  DeleteTuples,
  Expand,
  ListAuthorizationModels,
  ListObjects,
  ListUsersByObject,
  ReadAuthorizationModel,
  ReadTuples,
  WriteAuthorizationModel,
  WriteTuples,
};

// Namespace export for convenient usage
export const authzApi = {
  BatchCheck,
  Check,
  DeleteTuples,
  Expand,
  ListAuthorizationModels,
  ListObjects,
  ListUsersByObject,
  ReadAuthorizationModel,
  ReadTuples,
  WriteAuthorizationModel,
  WriteTuples,
};
